import miky from '../../Graphics/FotoGiocatori/Miky.jpeg'
import roby from '../../Graphics/FotoGiocatori/Roby.jpeg'
import zanna from '../../Graphics/FotoGiocatori/Zanna.jpeg'
import gigi from '../../Graphics/FotoGiocatori/Gigi.jpeg'
import gualo from '../../Graphics/FotoGiocatori/Gualo.jpeg'
import simo from '../../Graphics/FotoGiocatori/Simo.jpeg'
import mazzo from '../../Graphics/FotoGiocatori/Mazzo.jpeg'
import rampi from '../../Graphics/FotoGiocatori/Rampi.jpeg'
import prome from '../../Graphics/FotoGiocatori/Prome.jpeg'
import vito from '../../Graphics/FotoGiocatori/Vito.jpeg'
import moio from '../../Graphics/FotoGiocatori/Moio.jpeg'
import berto from '../../Graphics/FotoGiocatori/Berto.jpeg'
import poma from '../../Graphics/FotoGiocatori/Poma.jpeg'
import castro from '../../Graphics/FotoGiocatori/Castro.jpeg'
import belo from '../../Graphics/FotoGiocatori/Belo.jpeg'
import pulcio from '../../Graphics/FotoGiocatori/Pulcio.jpeg'


const Players = 
[
    {
        name : "Simone",
        surname : "Acerbis",
        number : 7,
        position : "Playmaker",
        photo : simo
    },
    {
        name : "Davide",
        surname : "Bertocchi",
        number : 30,
        position : "Playmaker",
        photo : berto
    },
    {
        name : "Marco",
        surname : "Pulcini",
        number : 8,
        position : "Playmaker",
        photo : pulcio
    },
    {
        name : "Michele",
        surname : "Carrara",
        number : 0,
        position : "Guardia",
        photo : miky
    },     
    {
        name : "Paolo",
        surname : "Gualini",
        number : 6,
        position : "Guardia",
        photo : gualo
    },     
    {
        name : "Marco",
        surname : "Moioli",
        number : 24,
        position : "Ala",
        photo : moio
    },
    {
        name : "Luigi",
        surname : "Pezzotta",
        number : 3,
        position : "Guardia",
        photo : gigi
    },
    {
        name : "Mattia",
        surname : "Poma",
        number : 32,
        position : "Ala",
        photo : poma
    },
    {
        name : "Nicola",
        surname : "Prometti",
        number : 17,
        position : "Centro",
        photo : prome
    },
    {
        name : "Andrea",
        surname : "Rampinelli",
        number : 9,
        position : "Guardia",
        photo : rampi
    },
    {
        name : "Davide",
        surname : "Vitali",
        number : 23,
        position : "Ala",
        photo : vito
    },
    {
        name : "Roberto",
        surname : "Vitali",
        number : 1,
        position : "Guardia",
        photo : roby
    },
    {
        name : "Stefano",
        surname : "Zanini",
        number : 2,
        position : "Coach",
        photo : zanna
    },
    {
        name : "Davide",
        surname : "Castrovinci",
        number : 10,
        position : "Ala",
        photo : castro
    },
    {
        name : "Simone",
        surname : "Belotti",
        number : 25,
        position : "Centro",
        photo : belo
    },
    {
        name : "Luca",
        surname : "Mazzoleni",
        number : 8,
        position : "Vecchie Glorie",
        photo : mazzo
    }
]

export default Players;